import { cn } from '@/utils/shadcn';
import React, { useEffect, useRef, useState } from 'react';
import { MdBrokenImage, MdImage } from 'react-icons/md';

export function ClientImage({
  wrapperProps,
  onLoad,
  defaultSize,
  style = {},
  className,
  src,
  ...props
}: Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'style'> & {
  wrapperProps?: React.HTMLAttributes<HTMLDivElement>;
  defaultSize?: React.CSSProperties;
  style?: React.CSSProperties;
}) {
  const imageRef = useRef<HTMLImageElement>(null);
  const [failed, markAsFailed] = useState(false);
  const [loading, setLoading] = useState(true);
  const [client, setClient] = useState(false);

  useEffect(() => {
    markAsFailed(false);
    setLoading(true);
  }, [src]);

  // because we do server side rendering, we need to check if the image is already loaded. Since it could have finished loading before the component was mounted and hence won't trigger the onLoad function during hydration. Luckily there is a complete property on the image element that we can use.
  useEffect(() => {
    setClient(true);
    // const img = imageRef?.current;
    // debugger;
    // if (img?.complete) {
    //   markAsFailed(false);
    //   setLoading(false);
    // }
  }, []);

  return (
    <div style={{ display: 'inline-block', ...style }}>
      {loading && (
        <div
          className="g-animate-pulse g-rounded-md g-bg-slate-50 g-text-slate-400 g-flex g-items-center g-justify-center g-me-3"
          style={{ width: '100%', height: '100%', ...defaultSize }}
        >
          <MdImage className="g-bg-slate-100" />
        </div>
      )}
      {failed && (
        <div className="gb-image-failed g-me-3">
          <div
            style={defaultSize}
            className="g-bg-slate-50 g-text-red-400 g-flex g-items-center g-justify-center g-rounded"
          >
            <MdBrokenImage />
          </div>
        </div>
      )}
      {client && !failed && (
        <img
          className={cn('g-bg-slate-50 g-rounded', className)}
          src={src}
          style={{ maxHeight: '100%', maxWidth: '100%', display: loading ? 'none' : 'block' }}
          ref={imageRef}
          onError={() => {
            markAsFailed(true);
            setLoading(false);
          }}
          onLoad={(e) => {
            setLoading(false);
            onLoad && onLoad(e);
          }}
          {...props}
        />
      )}
    </div>
  );
}
